export const Errors = {
  validRegistration: 'Deverá introduzir matrícula válida',
  validEmail: 'Deverá introduzir um email válido',
  passwordLength: 'Palavra-chave deverá ter no minimo 8 caracteres',
  validSamePassword: 'As Palavras-chave devem ser identicas',
  warningDeliveryReason: 'Máximo 8 caracteres',
  warningAllFieldsWithData: 'Todos os campos são de preenchimento obrigatório.',
  someFiltersNeeded: 'Pelo menos um dos filtros tem de ser preenchido',
  someFilterNeeded: 'Deverá preencher o filtro antes de pesquisar',
  somethingWrong: 'Aconteceu alguma coisa inesperada, o seu pedido não foi aceite.',
  warningEdit: 'O(s) seguinte(s) pedido(s): {orders} deverá preencher o número de volumes / número de paletes / paletes equivalentes ou não tem parceiro atribuído.',
  onlyNumerics: 'Só valores numéricos',
  onlyDecimals: 'Só valores numéricos / decimais',
  onlyBeta: 'Em testes',
  shouldChoose: 'Deverá seleccionar um pedido da listagem antes de utilizar este recurso',
  INVALID_VOLUMES_OR_WEIGHT: 'Peso superior ao permitido ou nº de volumes / peso inválidos.',
  INVALID_COMMUNICATION_STATUS: 'Acção não permitida sobre este(s) pedido(s) devido ao seu(s) estado(s).',
  downloadFile: 'Erro ao descarregar o ficheiro.',
  customerOrder: {
    error: {
      period: {
        exceeded: {
          '24h': 'Alteração de um pedido para um pequeno volume não é permitida até 24h antes da data de entrega.',
          '48h': 'Alteração de um pedido para um grande volume não é permitida até 48h antes da data de entrega.'
        }
      },
      reschedule: {
        unallowed: 'Alteração da data de entrega para um domingo não é permitida.'
      }
    }
  },
  pyxis: {
    change: {
      received: {
        not: {
          allowed: 'A alteração recebida não é permitida pelo Pyxis.'
        }
      }
    }
  },
  error: {
    emailexists: 'E-mail já existente, deverá seleccionar um outro válido.',
    cannot: {
      remove: {
        assigned: {
          orders: {
            in: {
              progress: 'Não se pode remover a matrícula porque tem pedidos associados a ela. Deve remover a matrícula a esses pedidos.'
            }
          }
        }
      }
    },
    user: {
      without: {
        associated: {
          carrier: 'Utilizador sem transportador asssociado.'
        }
      }
    },
    driver: {
      without: {
        associated: {
          vehicle: 'Motorista sem veiculo associado.'
        }
      }
    },
    communicationStatusEqualsReported: 'Este pedido não pode ser alterado, pois já foi comunicado'
  },
  warningNone: 'Sem informação disponível.'
}



// WEBPACK FOOTER //
// ./src/translations/pt/errors.js